import { render, staticRenderFns } from "./collection_records.vue?vue&type=template&id=cab734e2"
import script from "./collection_records.vue?vue&type=script&lang=js"
export * from "./collection_records.vue?vue&type=script&lang=js"
import style0 from "./collection_records.vue?vue&type=style&index=0&id=cab734e2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports